import { useNavigate } from "react-router-dom";
import { supportCards } from "@/mocks/help-center";

export default function SupportCards() {
  const navigate = useNavigate();

  return (
    <section>
      <div className="mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-3 tracking-tight font-heading">
          CONNECT WITH SUPPORT
        </h2>
        <div className="w-12 h-1 bg-accent mb-4 rounded-full" />
        <p className="text-base md:text-lg text-gray-500 max-w-2xl">
          Get immediate assistance from our dedicated support team or submit
          formal dispute resolution requests.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-6 md:gap-8">
        {supportCards.map((card, index) => (
          <button
            key={card.id}
            className="bg-white p-8 md:p-10 flex flex-col text-left transition-all duration-300 hover:-translate-y-1 rounded-2xl shadow-[0_2px_8px_rgba(15,64,143,0.05)] hover:shadow-[0_12px_32px_rgba(15,64,143,0.10)] border border-cream-dark/40"
            onClick={() => navigate(card.path)}
          >
            <div className="mb-6">
              <div
                className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-6 ${index === 0 ? 'bg-ice' : 'bg-lime'}`}
              >
                <i className={`${card.icon} text-2xl text-primary`} />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-2 text-primary font-heading">
                {card.title}
              </h3>
              <p className="leading-relaxed text-sm md:text-base text-gray-500">
                {card.description}
              </p>
            </div>
            <div className="mt-auto">
              <i className="ri-arrow-right-line text-xl text-accent" />
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}